import React from "react";
import logo from "./../../assets/img/logo.png";
import { Navbar, Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import * as code from "./../../config/Constants";

class HeaderLogin extends React.Component {
  render() {
    return (
      <div>
        <Navbar expand="lg" className="nav-head align-items-end">
          <Navbar.Brand href="">
            <img
              src={logo}
              alt="logo"
              style={{ width: "150px", padding: "5px" }}
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ml-auto">
              <Nav.Item>
                <NavLink
                  to="/login"
                  className="nav-link"
                  activeClassName="active"
                >
                  Login
                </NavLink>
              </Nav.Item>
              {/* {localStorage.getItem(code.IS_STRIPE_ENABLED) === "true"?
              <Nav.Item>
                <NavLink
                  to="/pricing"
                  className="nav-link"
                  activeClassName="active"
                >
                  Plans
                </NavLink>
              </Nav.Item>:""} */}
              <Nav.Item>
                <NavLink
                  to="/register"
                  className="nav-link"
                  activeClassName="active"
                >
                  Register
                </NavLink>
              </Nav.Item>
              <Nav.Item>
                <NavLink
                  to="/studios"
                  className="nav-link"
                  activeClassName="active"
                >
                  Studios
                </NavLink>
              </Nav.Item>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>
    );
  }
}

export default HeaderLogin;
